var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pendingAction)?_c('p',{staticClass:"mb-8 text-center m-auto"},[_vm._v(" Veuillez vous connecter ou créer votre compte pour valider votre action."),_c('br'),_vm._v(" Vos configurations ne seront pas supprimées. ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }